import { render, staticRenderFns } from "./DefaultLog.vue?vue&type=template&id=33ec5b7c"
import script from "./DefaultLog.vue?vue&type=script&lang=js"
export * from "./DefaultLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports